// Generouted, changes to this file will be overriden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client';

export type Path =
  | `/:lang?`
  | `/:lang?/accounting`
  | `/:lang?/additional-terms`
  | `/:lang?/admin`
  | `/:lang?/admin/:adminCompanyId`
  | `/:lang?/admin/:adminCompanyId/inheriters`
  | `/:lang?/admin/:adminCompanyId/modules`
  | `/:lang?/admin/:adminCompanyId/settings`
  | `/:lang?/admin/carriers`
  | `/:lang?/admin/companies`
  | `/:lang?/admin/company`
  | `/:lang?/admin/company/:companyId`
  | `/:lang?/admin/email-history`
  | `/:lang?/admin/email-monitoring`
  | `/:lang?/admin/email-monitoring2`
  | `/:lang?/admin/find-email-request`
  | `/:lang?/admin/find-resolved-emails`
  | `/:lang?/admin/i18n`
  | `/:lang?/admin/import-companies`
  | `/:lang?/admin/import/company-locations`
  | `/:lang?/admin/import/company-with-users`
  | `/:lang?/admin/import/users`
  | `/:lang?/admin/jobs-monitoring`
  | `/:lang?/admin/module-settings/ai-dispatcher/:companyId`
  | `/:lang?/admin/module-settings/ai-dispatcher/:companyId/activity`
  | `/:lang?/admin/module-settings/expedition/:companyId`
  | `/:lang?/admin/module-settings/supplier-notification/:companyId`
  | `/:lang?/admin/module-settings/timeslot/:companyId`
  | `/:lang?/admin/reporting/dashboard-recalculation`
  | `/:lang?/admin/requests`
  | `/:lang?/admin/requests/:requestId`
  | `/:lang?/admin/security/roles`
  | `/:lang?/admin/security/usage`
  | `/:lang?/admin/ship-companies`
  | `/:lang?/admin/tools/audit-log`
  | `/:lang?/admin/tools/calendar-card-designer`
  | `/:lang?/admin/tools/calendar-card-designer/:modelId`
  | `/:lang?/admin/tools/cargo-templates`
  | `/:lang?/admin/tools/console`
  | `/:lang?/admin/tools/elastic`
  | `/:lang?/admin/tools/web-alert`
  | `/:lang?/admin/tools/webhook-deliveries`
  | `/:lang?/admin/tools/webhook-tests`
  | `/:lang?/admin/users`
  | `/:lang?/auth`
  | `/:lang?/carrier`
  | `/:lang?/carrier/demand/:id`
  | `/:lang?/carrier/demands`
  | `/:lang?/carrier/multi-demands`
  | `/:lang?/carrier/multi-demands/:id`
  | `/:lang?/carrier/quick-actions/demand/:id`
  | `/:lang?/carrier/shipment/:id`
  | `/:lang?/carrier/shipments`
  | `/:lang?/company-notifications`
  | `/:lang?/company-profile`
  | `/:lang?/customer/admin/reports`
  | `/:lang?/customer/carrier-catalog`
  | `/:lang?/customer/carrier-group/:id`
  | `/:lang?/customer/carrier-groups`
  | `/:lang?/customer/carrier/:id`
  | `/:lang?/customer/carriers`
  | `/:lang?/customer/exceptions`
  | `/:lang?/customer/expedition`
  | `/:lang?/customer/expedition/:id`
  | `/:lang?/customer/expeditions`
  | `/:lang?/customer/job/:jobId`
  | `/:lang?/customer/jobs`
  | `/:lang?/customer/line`
  | `/:lang?/customer/line/:id`
  | `/:lang?/customer/locations`
  | `/:lang?/customer/locations/:id`
  | `/:lang?/customer/locations/:id/ramp/:rampId`
  | `/:lang?/customer/partner/:id`
  | `/:lang?/customer/partners`
  | `/:lang?/customer/route`
  | `/:lang?/customer/route/:id`
  | `/:lang?/customer/routes`
  | `/:lang?/email-history`
  | `/:lang?/expedition/:expeditionId`
  | `/:lang?/expedition/create`
  | `/:lang?/expedition/create/:entityId`
  | `/:lang?/expedition/import`
  | `/:lang?/inherited-companies`
  | `/:lang?/location/location-panel/:locationId`
  | `/:lang?/multi-demands`
  | `/:lang?/multi-demands/:multiDemandGroupId`
  | `/:lang?/my-profile`
  | `/:lang?/notifications`
  | `/:lang?/public/registration`
  | `/:lang?/reports/:reportId`
  | `/:lang?/settings`
  | `/:lang?/settings/ai-dispatcher`
  | `/:lang?/settings/ai-dispatcher/activity`
  | `/:lang?/settings/calendar-layout`
  | `/:lang?/settings/calendar-layout/:modelId`
  | `/:lang?/settings/partners`
  | `/:lang?/settings/partners/:id`
  | `/:lang?/settings/volumetric`
  | `/:lang?/shipments`
  | `/:lang?/shipments/:shipmentId`
  | `/:lang?/shipments/create-shipment`
  | `/:lang?/supplier-notifications`
  | `/:lang?/supplier-notifications/:supplierNotificationId`
  | `/:lang?/supplier-notifications/create-supplier-notification`
  | `/:lang?/supplier-notifications/create-supplier-notification-dap`
  | `/:lang?/supplier-notifications/duplicate-supplier-notification`
  | `/:lang?/supplier-notifications/process-shipment`
  | `/:lang?/test/calendar`
  | `/:lang?/test/dialog`
  | `/:lang?/test/error`
  | `/:lang?/test/gatepoc`
  | `/:lang?/test/map`
  | `/:lang?/test/menu`
  | `/:lang?/test/newCalendar`
  | `/:lang?/test/orders`
  | `/:lang?/test/pushpoc`
  | `/:lang?/test/rampcalendar`
  | `/:lang?/test/table`
  | `/:lang?/test/table2`
  | `/:lang?/test/upload`
  | `/:lang?/timeslots/:reservationId`
  | `/:lang?/timeslots/calendar`
  | `/:lang?/timeslots/cams`
  | `/:lang?/timeslots/cams-settings`
  | `/:lang?/timeslots/reservations`
  | `/:lang?/timeslots/visits`
  | `/:lang?/timeslots/visits/:visitId`
  | `/Maintenance`;

export type Params = {
  '/:lang?': { lang?: string };
  '/:lang?/accounting': { lang?: string };
  '/:lang?/additional-terms': { lang?: string };
  '/:lang?/admin': { lang?: string };
  '/:lang?/admin/:adminCompanyId': { lang?: string; adminCompanyId: string };
  '/:lang?/admin/:adminCompanyId/inheriters': { lang?: string; adminCompanyId: string };
  '/:lang?/admin/:adminCompanyId/modules': { lang?: string; adminCompanyId: string };
  '/:lang?/admin/:adminCompanyId/settings': { lang?: string; adminCompanyId: string };
  '/:lang?/admin/carriers': { lang?: string };
  '/:lang?/admin/companies': { lang?: string };
  '/:lang?/admin/company': { lang?: string };
  '/:lang?/admin/company/:companyId': { lang?: string; companyId: string };
  '/:lang?/admin/email-history': { lang?: string };
  '/:lang?/admin/email-monitoring': { lang?: string };
  '/:lang?/admin/email-monitoring2': { lang?: string };
  '/:lang?/admin/find-email-request': { lang?: string };
  '/:lang?/admin/find-resolved-emails': { lang?: string };
  '/:lang?/admin/i18n': { lang?: string };
  '/:lang?/admin/import-companies': { lang?: string };
  '/:lang?/admin/import/company-locations': { lang?: string };
  '/:lang?/admin/import/company-with-users': { lang?: string };
  '/:lang?/admin/import/users': { lang?: string };
  '/:lang?/admin/jobs-monitoring': { lang?: string };
  '/:lang?/admin/module-settings/ai-dispatcher/:companyId': { lang?: string; companyId: string };
  '/:lang?/admin/module-settings/ai-dispatcher/:companyId/activity': { lang?: string; companyId: string };
  '/:lang?/admin/module-settings/expedition/:companyId': { lang?: string; companyId: string };
  '/:lang?/admin/module-settings/supplier-notification/:companyId': { lang?: string; companyId: string };
  '/:lang?/admin/module-settings/timeslot/:companyId': { lang?: string; companyId: string };
  '/:lang?/admin/reporting/dashboard-recalculation': { lang?: string };
  '/:lang?/admin/requests': { lang?: string };
  '/:lang?/admin/requests/:requestId': { lang?: string; requestId: string };
  '/:lang?/admin/security/roles': { lang?: string };
  '/:lang?/admin/security/usage': { lang?: string };
  '/:lang?/admin/ship-companies': { lang?: string };
  '/:lang?/admin/tools/audit-log': { lang?: string };
  '/:lang?/admin/tools/calendar-card-designer': { lang?: string };
  '/:lang?/admin/tools/calendar-card-designer/:modelId': { lang?: string; modelId: string };
  '/:lang?/admin/tools/cargo-templates': { lang?: string };
  '/:lang?/admin/tools/console': { lang?: string };
  '/:lang?/admin/tools/elastic': { lang?: string };
  '/:lang?/admin/tools/web-alert': { lang?: string };
  '/:lang?/admin/tools/webhook-deliveries': { lang?: string };
  '/:lang?/admin/tools/webhook-tests': { lang?: string };
  '/:lang?/admin/users': { lang?: string };
  '/:lang?/auth': { lang?: string };
  '/:lang?/carrier': { lang?: string };
  '/:lang?/carrier/demand/:id': { lang?: string; id: string };
  '/:lang?/carrier/demands': { lang?: string };
  '/:lang?/carrier/multi-demands': { lang?: string };
  '/:lang?/carrier/multi-demands/:id': { lang?: string; id: string };
  '/:lang?/carrier/quick-actions/demand/:id': { lang?: string; id: string };
  '/:lang?/carrier/shipment/:id': { lang?: string; id: string };
  '/:lang?/carrier/shipments': { lang?: string };
  '/:lang?/company-notifications': { lang?: string };
  '/:lang?/company-profile': { lang?: string };
  '/:lang?/customer/admin/reports': { lang?: string };
  '/:lang?/customer/carrier-catalog': { lang?: string };
  '/:lang?/customer/carrier-group/:id': { lang?: string; id: string };
  '/:lang?/customer/carrier-groups': { lang?: string };
  '/:lang?/customer/carrier/:id': { lang?: string; id: string };
  '/:lang?/customer/carriers': { lang?: string };
  '/:lang?/customer/exceptions': { lang?: string };
  '/:lang?/customer/expedition': { lang?: string };
  '/:lang?/customer/expedition/:id': { lang?: string; id: string };
  '/:lang?/customer/expeditions': { lang?: string };
  '/:lang?/customer/job/:jobId': { lang?: string; jobId: string };
  '/:lang?/customer/jobs': { lang?: string };
  '/:lang?/customer/line': { lang?: string };
  '/:lang?/customer/line/:id': { lang?: string; id: string };
  '/:lang?/customer/locations': { lang?: string };
  '/:lang?/customer/locations/:id': { lang?: string; id: string };
  '/:lang?/customer/locations/:id/ramp/:rampId': { lang?: string; id: string; rampId: string };
  '/:lang?/customer/partner/:id': { lang?: string; id: string };
  '/:lang?/customer/partners': { lang?: string };
  '/:lang?/customer/route': { lang?: string };
  '/:lang?/customer/route/:id': { lang?: string; id: string };
  '/:lang?/customer/routes': { lang?: string };
  '/:lang?/email-history': { lang?: string };
  '/:lang?/expedition/:expeditionId': { lang?: string; expeditionId: string };
  '/:lang?/expedition/create': { lang?: string };
  '/:lang?/expedition/create/:entityId': { lang?: string; entityId: string };
  '/:lang?/expedition/import': { lang?: string };
  '/:lang?/inherited-companies': { lang?: string };
  '/:lang?/location/location-panel/:locationId': { lang?: string; locationId: string };
  '/:lang?/multi-demands': { lang?: string };
  '/:lang?/multi-demands/:multiDemandGroupId': { lang?: string; multiDemandGroupId: string };
  '/:lang?/my-profile': { lang?: string };
  '/:lang?/notifications': { lang?: string };
  '/:lang?/public/registration': { lang?: string };
  '/:lang?/reports/:reportId': { lang?: string; reportId: string };
  '/:lang?/settings': { lang?: string };
  '/:lang?/settings/ai-dispatcher': { lang?: string };
  '/:lang?/settings/ai-dispatcher/activity': { lang?: string };
  '/:lang?/settings/calendar-layout': { lang?: string };
  '/:lang?/settings/calendar-layout/:modelId': { lang?: string; modelId: string };
  '/:lang?/settings/partners': { lang?: string };
  '/:lang?/settings/partners/:id': { lang?: string; id: string };
  '/:lang?/settings/volumetric': { lang?: string };
  '/:lang?/shipments': { lang?: string };
  '/:lang?/shipments/:shipmentId': { lang?: string; shipmentId: string };
  '/:lang?/shipments/create-shipment': { lang?: string };
  '/:lang?/supplier-notifications': { lang?: string };
  '/:lang?/supplier-notifications/:supplierNotificationId': { lang?: string; supplierNotificationId: string };
  '/:lang?/supplier-notifications/create-supplier-notification': { lang?: string };
  '/:lang?/supplier-notifications/create-supplier-notification-dap': { lang?: string };
  '/:lang?/supplier-notifications/duplicate-supplier-notification': { lang?: string };
  '/:lang?/supplier-notifications/process-shipment': { lang?: string };
  '/:lang?/test/calendar': { lang?: string };
  '/:lang?/test/dialog': { lang?: string };
  '/:lang?/test/error': { lang?: string };
  '/:lang?/test/gatepoc': { lang?: string };
  '/:lang?/test/map': { lang?: string };
  '/:lang?/test/menu': { lang?: string };
  '/:lang?/test/newCalendar': { lang?: string };
  '/:lang?/test/orders': { lang?: string };
  '/:lang?/test/pushpoc': { lang?: string };
  '/:lang?/test/rampcalendar': { lang?: string };
  '/:lang?/test/table': { lang?: string };
  '/:lang?/test/table2': { lang?: string };
  '/:lang?/test/upload': { lang?: string };
  '/:lang?/timeslots/:reservationId': { lang?: string; reservationId: string };
  '/:lang?/timeslots/calendar': { lang?: string };
  '/:lang?/timeslots/cams': { lang?: string };
  '/:lang?/timeslots/cams-settings': { lang?: string };
  '/:lang?/timeslots/reservations': { lang?: string };
  '/:lang?/timeslots/visits': { lang?: string };
  '/:lang?/timeslots/visits/:visitId': { lang?: string; visitId: string };
};

export type ModalPath = never;

export const { Link, Navigate } = components<Path, Params>();
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>();
export const { redirect } = utils<Path, Params>();
